import { combineReducers } from "@reduxjs/toolkit";
import { exportSlice } from "./exportSlide";

export const exportRootReducer = combineReducers({
    exportAssignment: exportSlice.reducer
});